const sidebar = document.querySelector('.sidebar');

if (null !== sidebar) {
	const sidebarToggle = document.querySelector('#toggle-sidebar');
	sidebarToggle.onclick = () => {
		sidebar.classList.toggle('sidebar--open');
	};

	const sidebarClose = document.querySelector('#close-sidebar');
	sidebarClose.onclick = () => {
		sidebar.classList.remove('sidebar--open');
	};
}
